import "./ticket.scss";
import {
  TicketLayoutDetailModel,
  TicketLayoutModel,
} from "../../models/ticketLayoutModel";
import logo from "../../../assets/imageIcon.svg";

export default function Ticket(props: {
  isRealTicket?: boolean;
  ticketLayout: TicketLayoutModel;
  backgroundImage?: string;
  logoImage?: string;
  eventName?: string;
  fullName?: string;
  id?: string;
  date?: boolean;
  description?: string;
  ticketId?: string;
}) {
  function getLayoutByOrder(
    ticketLayout: TicketLayoutModel,
    orderNumber: number
  ): TicketLayoutDetailModel | undefined {
    let result;
    Object.keys(ticketLayout).forEach((e) => {
      if (ticketLayout[e as keyof TicketLayoutModel].order == orderNumber)
        result = ticketLayout[e as keyof TicketLayoutModel];
    });
    return result;
  }

  function formatDate(date: Date) {
    var year = date.getFullYear().toString();
    var month = (date.getMonth() + 101).toString().substring(1);
    var day = (date.getDate() + 100).toString().substring(1);
    return day + "/" + month + "/" + year;
  }

  function getTextFromKey(key?: string) {
    switch (key) {
      case "eventName":
        return props.eventName;
      case "date":
        return props.date ? formatDate(new Date(Date.now())) : undefined;
      case "fullNameAndId":
        return props.fullName || props.ticketId
          ? `${props.fullName ?? ""} ${props.ticketId ?? ""}`
          : undefined;
      case "description":
        return props.description;
    }
  }
  return (
    <div
      className="ticket"
      id={props.id}
      style={{
        backgroundImage: ` url(${props.backgroundImage})`,
        backgroundSize: "100% 100%",
      }}
    >
      <div className="ticket-content">
        {[...Array(3)].map((e, i) => (
          <div
            key={i}
            style={{
              color: getLayoutByOrder(props.ticketLayout, i)?.color,
              fontWeight: getLayoutByOrder(props.ticketLayout, i)?.fontWeight,
              fontSize: getLayoutByOrder(props.ticketLayout, i)?.fontSize,
              width: "100%",
              textAlign: "start",
            }}
          >
            {props.isRealTicket
              ? getTextFromKey(getLayoutByOrder(props.ticketLayout, i)?.key)
              : getLayoutByOrder(props.ticketLayout, i)?.hintText}
          </div>
        ))}
        <div style={{ flex: 1 }} />
        <div
          style={{
            color: getLayoutByOrder(props.ticketLayout, 3)?.color,
            fontWeight: getLayoutByOrder(props.ticketLayout, 3)?.fontWeight,
            fontSize: getLayoutByOrder(props.ticketLayout, 3)?.fontSize,
            width: "100%",
            textAlign: "start",
          }}
        >
          {props.isRealTicket
            ? getTextFromKey(getLayoutByOrder(props.ticketLayout, 3)?.key)
            : getLayoutByOrder(props.ticketLayout, 3)?.hintText}
        </div>
      </div>
      <div className="ticket-logo-container">
        <div className="ticket-seperator" />
        <img className="ticket-logo" src={props.logoImage ?? logo} />
      </div>
    </div>
  );
}
